import { Box, FileText } from "lucide-react";
import { cn } from "@/lib/cn";

export type AbaDoServico = "dados" | "ficha";

const ABAS = [
  { chave: "dados", rotulo: "Nome e materiais", icone: Box },
  { chave: "ficha", rotulo: "Ficha técnica", icone: FileText },
] as const;

export function AbasDoServico({ aba, onAba }: { aba: AbaDoServico; onAba: (aba: AbaDoServico) => void }) {
  return (
    <div className="flex gap-1 rounded-lg border border-zinc-200 bg-zinc-50 p-1 dark:border-border dark:bg-muted/40">
      {ABAS.map(({ chave, rotulo, icone: Icone }) => (
        <button
          key={chave}
          type="button"
          onClick={() => onAba(chave)}
          className={cn(
            "inline-flex h-9 flex-1 items-center justify-center gap-2 rounded-md text-sm font-semibold transition-colors",
            aba === chave
              ? "bg-brand-600 text-white shadow-sm"
              : "text-zinc-600 hover:text-zinc-900 dark:text-muted-foreground dark:hover:text-foreground",
          )}
        >
          <Icone className="h-4 w-4" />
          {rotulo}
        </button>
      ))}
    </div>
  );
}
